
<form [hidden]="hideEditView" [formGroup]="dynamicForm" (ngSubmit)="onSubmit()">
    <div class="form-group row" *ngFor="let field of formFields">
        <label class="col-sm-3 col-form-label" [for]="field.name">{{ field.label }}</label>
        <div *ngIf="field.type=='textarea'" class="col-md-9">
            <textarea (blur)="changeFormCallback()" (wheel)="disableWheel($event)" class="form-control" [id]="field.name" [formControlName]="field.name" [readonly]="field?.readonly"
                [attr.placeholder]="field.placeholder"></textarea>

            <!-- Display validation error messages -->
            <div *ngIf="dynamicForm.get(field.name)?.invalid && dynamicForm.get(field.name)?.touched">
                <small *ngIf="dynamicForm.get(field.name)?.errors?.['required']">
                    {{ field.label }} is required.
                </small>
                <small *ngIf="dynamicForm.get(field.name)?.errors?.['email']">{{ field.label }} must be a
                    valid email.</small>
                <small *ngIf="dynamicForm.get(field.name)?.errors?.['min']">{{ field.label }} must be at
                    least 18.</small>
            </div>
        </div>
         <div *ngIf="field.type!='textarea'" class="col-md-9">
            <input (blur)="changeFormCallback()" (wheel)="disableWheel($event)" class="form-control" [id]="field.name" [type]="field.type" [formControlName]="field.name" [readonly]="field?.readonly"
                [attr.placeholder]="field.placeholder">

            <!-- Display validation error messages -->
            <div *ngIf="dynamicForm.get(field.name)?.invalid && dynamicForm.get(field.name)?.touched">
                <small *ngIf="dynamicForm.get(field.name)?.errors?.['required']">
                    {{ field.label }} is required.
                </small>
                <small *ngIf="dynamicForm.get(field.name)?.errors?.['email']">{{ field.label }} must be a
                    valid email.</small>
                <small *ngIf="dynamicForm.get(field.name)?.errors?.['min']">{{ field.label }} must be at
                    least 18.</small>
            </div>
        </div>
    </div>
    <button [hidden]="hideCancelButton"  (click)="hideForm()" class="btn btn-primary" type="button">Cancel</button>
    <button class="btn btn-primary float-end" type="submit" [disabled]="dynamicForm.invalid">{{nameOfSubmitBtb}}</button>
</form>
<div [hidden]="!hideEditView" class="row justify-content-end mb-4">
    <div class="col-md-3">
        <button (click)="showForm()" class="btn btn-primary float-end" type="button">Edit</button>
    </div>
</div>
<div [hidden]="!hideEditView" class="form-group row" *ngFor="let field of formFields">
    <label class="col-sm-7 col-form-label" [for]="field.name">{{ field.label }}</label>
    <div class="col-md-5">
        <label class="col-sm-5 col-form-label" [for]="field.name">{{ setFormData?.[field.name] || 'N/A' }}</label>
    </div>
</div>